import { render, staticRenderFns } from "./FileSystemToolbar.vue?vue&type=template&id=24da64f8&"
import script from "./FileSystemToolbar.vue?vue&type=script&lang=ts&"
export * from "./FileSystemToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports